import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { type DeleteUserResult } from "../endpoints";

/** Super-admin only: hard-delete a user. Reassigns their jobs to the
 * caller before removing the row. Invalidates the user directory so
 * the deleted row drops out, and the job list so the freshly-inherited
 * jobs surface for the caller. */
export function useDeleteUser(): UseMutationResult<DeleteUserResult, Error, string> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => client.deleteUser(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["users"] });
      qc.invalidateQueries({ queryKey: ["jobs"] });
    },
  });
}
